import { useState } from "react";
import img from "../assets/images/submit.svg";

const Form = props => {

    const [data, setData] = useState({});
    const [submit, setSubmit] = useState(false);
    const postData = async () => {
        setSubmit(true);
        const config = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        }
        const response = await fetch("https://3t4cskbid5.execute-api.ap-south-1.amazonaws.com/prod/storeContacts", config).catch(err=>{console.log(err)})
        if (response.ok) {
            await response.json();
        }
    }

    return (
        <div className="contact-form--1">
            <div className="container">
                <div className="row row--35 align-items-start">
                    {!submit && (<div className="col-lg-6 order-2 order-lg-1" style={{width:"100%"}}>
                        <div className="section-title text-left mb--50">
                            <h2 className="title">Contact Me.</h2>
                            <p className="description">We will get back to you as soon as possible.</p>
                        </div>
                        <div className="form-wrapper">
                            <form onSubmit={e=>{e.preventDefault();return false}}>
                                <div className="rn-form-group">
                                    <input type="text" name="fullname" onChange={e=>{data.fullname=e.target.value;setData(data)}} maxLength="50" placeholder="Your Name" required="" />
                                </div>
                                <div className="rn-form-group">
                                    <input type="email" name="email" onChange={e=>{data.email=e.target.value;setData(data)}} maxLength="50" placeholder="Your Email" required="" />
                                </div>
                                <div className="rn-form-group">
                                    <input type="text" name="phone" onChange={e=>{data.phone=e.target.value;setData(data)}} maxLength="13" placeholder="Phone Number" required=""/>
                                </div>
                                <div className="rn-form-group">
                                    <input type="text" name="subject" onChange={e=>{data.subject=e.target.value;setData(data)}} maxLength="100" placeholder="Subject" required=""/>
                                </div>
                                <div className="rn-form-group">
                                    <textarea name="message" onChange={e=>{data.message=e.target.value;setData(data)}} maxLength="500" placeholder="Your Message" required=""></textarea>
                                </div>
                                <div className="rn-form-group">
                                    <button className="rn-button-style--2 btn-solid" onClick={postData}>Submit Now</button>
                                </div>
                                <div className="rn-form-group"></div>
                            </form>
                        </div>
                    </div>)}
                    {submit && (<div class="section-title text-left mb--50 mt--50" style={{textAlign:"center"}}>
                        <img src={img} style={{width:"20%",margin:"auto"}}/>
                        <span style={{color:"#1d8102",fontSize:"60px",display:"block"}}>Submitted</span>
                        <button className="rn-button-style--2 btn-solid" style={{marginTop:"10%"}} onClick={props.onClick}>Close</button>
                    </div>)}
                </div>
            </div>
        </div>
    );
}

export default Form;